<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="21"
        height="20"
        viewBox="0 0 21 20"
        fill="none"
    >
    <path
        d="M5.6001 12.5L10.6001 7.5L15.6001 12.5"
        stroke="currentColor"
        stroke-width="1.66667"
        stroke-linecap="round"
        stroke-linejoin="round"
    />
    </svg>
</template>

<script>
    export default {
    name: "ChevronUpIcon",
    };
</script>